<template>
    <component :is="icon" />
    <!-- class="icon" :style="{height: height + 'px'}" v-bind="$attrs" -->
</template>

<script>
import HandFinger from "@/components/icons/HandFinger.vue";
import Message from "@/components/icons/Message.vue";
import FileDownload from "@/components/icons/FileDownload.vue";
import School from "@/components/icons/School.vue";
import User from "@/components/icons/User.vue";
import Users from "@/components/icons/Users.vue";
import PlayerFirst from "@/components/icons/PlayerFirst.vue";
import PlayerLast from "@/components/icons/PlayerLast.vue";
import PlayerNext from "@/components/icons/PlayerNext.vue";
import PlayerPrev from "@/components/icons/PlayerPrev.vue";
import ArrowUp from "@/components/icons/ArrowUp.vue";
import ArrowDown from "@/components/icons/ArrowDown.vue";
import QuestionMark from "@/components/icons/QuestionMark.vue";
import Mail from "@/components/icons/Mail.vue";
import ChevronDown from "@/components/icons/ChevronDown.vue";
import ChevronDownWhite from "@/components/icons/ChevronDownWhite.vue";
import Search from "@/components/icons/Search.vue";
import Edit from "@/components/icons/Edit.vue";
import Phone from "@/components/icons/Phone.vue";
import Plus from "@/components/icons/Plus.vue";
import MagnifyingGlass from "@/components/icons/MagnifyingGlass.vue";
import Pointer from "@/components/icons/Pointer.vue";
import Calendar from "@/components/icons/Calendar.vue";
import Filter from "@/components/icons/Filter.vue";
import Pickup from "@/components/icons/Pickup.vue";
import DeliveryMan from "@/components/icons/DeliveryMan.vue";
import DeliveryMan2 from "@/components/icons/DeliveryMan2.vue";
import UserPicture from "@/components/icons/UserPicture.vue";
import Snow from "@/components/icons/Snow.vue";
import Minus from "@/components/icons/Minus.vue";
import VehicleTruck from "@/components/icons/VehicleTruck.vue";
import VehicleTruckOff from "@/components/icons/VehicleTruckOff.vue";
import VehicleTruckTrolley from "@/components/icons/VehicleTruckTrolley.vue";
import GuestbookUserCheck from "@/components/icons/GuestbookUserCheck.vue";
import GuestbookUserOff from "@/components/icons/GuestbookUserOff.vue";
import GuestbookUserQuestion from "@/components/icons/GuestbookUserQuestion.vue";
import CameraPlus from "@/components/icons/CameraPlus.vue";
import Trash from "@/components/icons/Trash.vue";
import EditPen from "@/components/icons/EditPen.vue";
import Lock from "@/components/icons/Lock.vue";
import LockOpen from "@/components/icons/LockOpen.vue";
import Battery from "@/components/icons/Battery.vue";
import BatteryCharging from "@/components/icons/BatteryCharging.vue";
import Writing from "@/components/icons/Writing.vue";
import Eye from "@/components/icons/Eye.vue";
import CalendarNavbar from "@/components/icons/CalendarNavbar.vue";
import VehicleAddNavbar from "@/components/icons/VehicleAddNavbar.vue";
import UserPlus from "@/components/icons/UserPlus.vue";
import Logout from "@/components/icons/Logout.vue";
import GatehouseNavbar from "@/components/icons/GatehouseNavbar.vue";
import MobileDeviceNavbar from "@/components/icons/MobileDeviceNavbar.vue";
import PatrolRouteNavbar from "@/components/icons/PatrolRouteNavbar.vue";
import PatrolLogNavbar from "@/components/icons/PatrolLogNavbar.vue";
import NfcTagNavbar from "@/components/icons/NfcTagNavbar.vue";
import CommodityUnitNavbar from "@/components/icons/CommodityUnitNavbar.vue";
import NotificationNavbar from "@/components/icons/NotificationNavbar.vue";
import Check from "@/components/icons/Check.vue";
import Copy from "@/components/icons/Copy.vue";
import RepeatNavbar from "@/components/icons/RepeatNavbar.vue";
import PatrolPhotoNavbar from "@/components/icons/PatrolPhotoNavbar.vue";
import SettingsNavbar from "@/components/icons/SettingsNavbar.vue";
import BozpNavbar from "@/components/icons/BozpNavbar.vue";

export default {
    name: "icon",
    // inheritAttrs: false,
    props: {
        icon: {type: String, required: true},
        // width: {type: Number, required: false, default: 24},
        // height: {type: Number, required: false, default: 24}
    },
    components: {
        PlayerFirst,
        PlayerLast,
        PlayerNext,
        PlayerPrev,
        HandFinger,
        Message,
        FileDownload,
        School,
        User,
        Users,
        ArrowUp,
        ArrowDown,
        QuestionMark,
        Mail,
        ChevronDown,
        ChevronDownWhite,
        Search,
        Edit,
        Phone,
        Plus,
        MagnifyingGlass,
        Pointer,
        Calendar,
        Filter,
        Pickup,
        DeliveryMan,
        DeliveryMan2,
        UserPicture,
        Snow,
        Minus,
        VehicleTruck,
        VehicleTruckOff,
        VehicleTruckTrolley,
        GuestbookUserCheck,
        GuestbookUserOff,
        GuestbookUserQuestion,
        CameraPlus,
        Trash,
        EditPen,
        Lock,
        LockOpen,
        Battery,
        BatteryCharging,
        Writing,
        Eye,
        CalendarNavbar,
        VehicleAddNavbar,
        UserPlus,
        Logout,
        GatehouseNavbar,
        MobileDeviceNavbar,
        PatrolRouteNavbar,
        PatrolLogNavbar,
        NfcTagNavbar,
        CommodityUnitNavbar,
        NotificationNavbar,
        Check,
        Copy,
        RepeatNavbar,
        PatrolPhotoNavbar,
        SettingsNavbar,
        BozpNavbar,
    }
}
</script>

<style lang="scss" scoped>
    .icon {
        display: inline-block;
        vertical-align: middle;
    }
</style>